import React, { useEffect, useState, useRef } from "react";
import "./Stages.css";
import Btn from "../../Components/Btn/Btn";
import ReactCardFlip from "react-card-flip";

const LazyImage = ({ src, alt, className }) => {
  const imgRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const img = imgRef.current;
          img.src = img.dataset.src;
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current);
      }
    };
  }, []);

  return (
    <img
      ref={imgRef}
      data-src={src}
      alt={alt}
      className={`${className} ${loaded ? "" : "blur"}`}
      onLoad={() => setLoaded(true)}
    />
  );
};

const Stages = () => {
  // Componenta existentă
  const [winWidth, setWinWidth] = useState(window.innerWidth);
  const [isFlipped, setIsFlipped] = useState(Array(4).fill(false));

  useEffect(() => {
    const handleResize = () => {
      setWinWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleFlip = (index) => {
    setIsFlipped((prev) => prev.map((flip, i) => (i === index ? !flip : flip)));
  };

  const cards = [
    {
      index: "01",
      title: "Consultanță & <br /> Strategie",
      img: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1726768070/RealCode/stages/ills2_hxjnni.svg",
      color: "accent",
      description:
        "Începem cu o analiză detaliată a nevoilor tale. Stabilim împreună arhitectura, funcționalitățile cheie și direcția strategică a proiectului pentru a asigura succesul.",
    },
    {
      index: "02",
      title: "Design UI/UX & <br /> Prototip",
      img: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1726768070/RealCode/stages/ills1_vbirbc.svg",
      color: "accent",
      description:
        "Creăm interfețe intuitive și atractive, focusate pe o experiență de utilizare excepțională. Realizăm wireframes, prototipuri interactive și designul vizual final.",
    },
    {
      index: "03",
      title: "Dezvoltare & <br /> Implementare",
      img: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1726934479/RealCode/stages/tokyo-many-browser-windows-with-different-information_1_2_-transformed_wlc1m7.png",
      color: "accent",
      description:
        "Echipa noastră de programatori transformă designul într-o platformă web performantă, sigură și scalabilă, folosind cele mai moderne tehnologii.",
    },
    {
      index: "04",
      title: "Lansare & <br /> Evoluție",
      img: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1726934558/RealCode/stages/tokyo-sending-messages-from-one-place-to-another_1_1_-transformed_p7vgku.png",
      color: "accent",
      description:
        "După testări riguroase, lansăm platforma și monitorizăm performanța. Rămânem partenerul tău pe termen lung pentru mentenanță, suport și dezvoltări viitoare.",
    },
  ];

  return (
    <section className="stages" id="services">
      <div className="sub-title">
        <h2 className="text-2">
          Procesul nostru <span className="highlight">de lucru</span>
        </h2>
      </div>
      <div className="cards">
        {cards.map((card, index) => (
          <ReactCardFlip
            isFlipped={isFlipped[index]}
            flipDirection="vertical"
            key={index}
          >
            <div
              className={`card ${winWidth > 520 ? card.color : ""}`}
              onClick={() => handleFlip(index)}
            >
              <LazyImage
                src={card.img}
                alt={card.title.replace(/<br \/>/g, " ")}
                className="card-img"
              />
              <h3>
                <div className="card-index">{card.index}</div>
                <span dangerouslySetInnerHTML={{ __html: card.title }}></span>
              </h3>
              <div className="card-switch">
                <img
                  src="https://res.cloudinary.com/dsqwnuyiw/image/upload/v1726410187/RealCode/stages/Arrow_1_rxdkfa.svg"
                  alt="arrow"
                />
                <p className="p-1">Află mai multe</p>
              </div>
            </div>

            <div
              className={`card card-back ${winWidth > 520 ? card.color : ""}`}
              onClick={() => handleFlip(index)}
            >
              <LazyImage
                src={card.img}
                alt={card.title.replace(/<br \/>/g, " ")}
                className="card-img"
              />
              <h3>
                <div className="card-index">{card.index}</div>
                <p className="p-1">{card.description}</p>
              </h3>
              <div className="card-switch card-switch-back">
                <img
                  src="https://res.cloudinary.com/dsqwnuyiw/image/upload/v1726410187/RealCode/stages/Arrow_1_rxdkfa.svg"
                  alt="arrow"
                />
                <p className="p-1">
                  <a href="https://wa.me/40728739818">Contactează-ne acum!</a>
                </p>
              </div>
            </div>
          </ReactCardFlip>
        ))}
      </div>
    </section>
  );
};

export default Stages;
